<template>
  <div @mouseover="mouseover" v-if="visible" class="outer-container" v-bind:style="{ left: containerLeft + 'px', top: containerTop + 'px'}">
    <div v-if="!moveContainerLeft" class="arrow arrow-left"></div>
    <div
      v-if="loading"
      class="container"
    >
      Loading...
    </div>
    <div
      v-else
      class="container"
    >
      <div>
        <div class="row"><span style="font-weight: 600;">({{vejkode}}) {{vejnavn}}</span></div>
        <div class="row"><span>{{postnummer}}</span></div>
      </div>
      <div>
        <div class="row" style="just">
          <span>{{vejmidteType}}</span>
          <span>ID: {{geoDkId}}</span>
        </div>
      </div>
    </div>
    <div v-if="moveContainerLeft" class="arrow arrow-right"></div>
  </div>
</template>

<script>
export default {
  name: 'popup',
  props: {
    x: Number,
    y: Number,
    visible: Boolean,
    loading: Boolean,
    vejkode: String,
    kommuneKode: Number,
    geoDkId: Number,
    vejmidteType: String,
    vejnavn: String,
    postnummer: String,
    mouseover: Function,
  },
  computed: {
    moveContainerLeft () { // Styrer position og om pilen peger til højre eller venstre
      if (window.innerWidth - this.x < 400) {
        return true;
      }
      return false;
    },
    containerLeft () {
      if (this.moveContainerLeft) {
        return this.x - 200;
      } else {
        return this.x + 100;
      }
    },
    containerTop () {
      if (this.y < 100) {
        return 10;
      } else if (window.innerHeight - this.y < 100) {
        return window.innerHeight - 100;
      }
      return this.y - 45;
    },
    windowWidth () {
      return window.innerWidth;
    },
  },
};
</script>

<style lang="scss" scoped>
.outer-container {
  position: absolute;
  z-index: 2;
  display: flex;
  align-items: center;
}
.container {
  width: 230px;
  height: 90px;
  padding: 10px 20px;
  border-radius: 2px;
  background-color: white;
  box-shadow: 0 2px 10px 0 rgba(92,109,150,0.25);
  font-size: 14px;
  letter-spacing: -0.77px;

  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.row {
  display: flex;
  justify-content: space-between;
}

.arrow {
  z-index: 2;
  width: 0;
  height: 0;
  border-left: 20px solid transparent;
  border-right: 20px solid transparent;
  border-top: 20px solid transparent;
  border-bottom: 20px solid transparent;
  margin: -1px auto;
  filter: drop-shadow(0 2px 10px 0 rgba(92,109,150,0.25));
}
.arrow-left{
  border-right: 20px solid #FFFFFF;
}
.arrow-right{
  border-left: 20px solid #FFFFFF;
}
</style>
